import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateTableModel } from '../../models/config/translate_table.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';

import { Subscription } from 'rxjs';

import { Observable } from 'rxjs';
import { FormControl, NgForm } from '@angular/forms';

import { ReportModel } from '../report.model';
import { ReportService } from '../report.service';
import { Router } from '@angular/router';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { RefreshService } from '../refresh.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-report-create',
  templateUrl: './report-create.component.html',
  styleUrls: ['./report-create.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ReportCreateComponent implements OnInit {

  public reportModel = new ReportModel();
  public reportModelQuery = new ReportModel();
  public dynaParms: ReportModel[] = [];

  public resCat: ReportModel[] = [];
  public resDist: ReportModel[] = [];
  public excelResponse: ReportModel[] = [];

  private subscriptions: Subscription[] = [];

  public dataSource = new MatTableDataSource<TranslateTableModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  public displayedColumns = [];

  public sqlquery: string;
  public showLoading: boolean;

  public cat: string;
  public sqlparms: string = "";
  public sqllabels: string = "";
  public distid: number;
  public parmsLength: number;
  public dummyForm: NgForm;
  public insertReportForm: NgForm;
  public showRunBtn: boolean = true;
  public showSaveBtn: boolean = true;


  filteredCategoryOptions: Observable<any[]>;
  filteredDistOptions: Observable<any[]>;
  myControl = new FormControl();
  myControlDist = new FormControl();

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  isAccessDisabled: boolean = false;

  constructor(private globalService: GlobalService, private router: Router, private reportService: ReportService,
    public ete: ExportExcelService, private authGaurdService: AuthGaurdService, private notificationService: NotificationService, private refreshService: RefreshService) {
  }

  ngOnInit() {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('create-report');

    this.refreshService.notifyObservable$.subscribe(res => {
      if (res.refresh) {
        this.getDistributionData();
      }
    })

    this.getCategoryData();
    this.getDistributionData();
  }

  public saveReport(reportForm: NgForm): void {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      this.showRunBtn = false;
      this.showSaveBtn = true;
      console.log("saveReport");
      this.insertReportForm = reportForm;
      console.log("category = " + this.reportModel.category);
      console.log("distId = " + this.reportModel.distId);
      console.log("reportSql = " + this.reportModel.reportSql);
      //console.log("reportForm.value = " + JSON.stringify(reportForm.value));

      this.cat = this.reportModel.category;
      this.distid = this.reportModel.distId;

      this.getParms(this.reportModel.reportSql, this.insertReportForm, "S");
    }

  }

  public runReport() {
    this.showRunBtn = true;
    this.showSaveBtn = false;
    //console.log("runReport");
    this.sqlquery = this.reportModel.reportSql;
    //console.log("SQL Query === " + this.sqlquery);
    //console.log("this.parms === " + this.parms);
    if (this.sqlquery == "") {
      this.notificationService.sendNotification(NotificationType.ERROR, "Enter SQl Query");
    } else {
      if (this.sqlparms == "") {
        this.sqlparms = "NA";
      }
      this.getParms(this.sqlquery, this.dummyForm, "R");
    }
  }

  public updateParms(status: string) {
    console.log("SQL PARMS === " + JSON.stringify(this.dynaParms));
    this.sqlparms = "";
    this.sqllabels = "";
    for (var i = 0; i < this.parmsLength; i++) {
      this.sqlparms = this.sqlparms + this.dynaParms[i].sqlParams + ",";
      this.sqllabels = this.sqllabels + this.dynaParms[i].sqlLabels + ",";
    }
    this.sqlparms = this.sqlparms.slice(0, -1);
    this.sqllabels = this.sqllabels.slice(0, -1);
    console.log("this.sqlparms===" + this.sqlparms);
    console.log("this.sqllabels===" + this.sqllabels);
    console.log("status=" + status);
    if (status == "R") {
      this.runSQlQuery(this.sqlquery, this.sqlparms);
    } else {
      this.insertReport(this.insertReportForm, this.sqlparms,this.sqllabels);
    }

    this.clickButton('closeParmModalButton');
  }

  private getParms(sqlquery: string, reportForm: NgForm, status: string) {
    console.log("getParms");
    //console.log("sqlquery===" + sqlquery);
    if (sqlquery.indexOf("~") !== -1) {
      //console.log("getParms if");
      this.parmsLength = sqlquery.split("~").length - 1;
      this.dynaParms = [];
      for (var i = 0; i < this.parmsLength; i++) {
        const reportParmModel = new ReportModel();
        this.dynaParms.push(reportParmModel);
      }
      this.clickButton('onOpenParmModel');
    } else {
      //console.log("getParms else");
      if (status == "R") {
        //console.log("getParms esle if");
        this.runSQlQuery(sqlquery, this.sqlparms);
      } else {
        //console.log("getParms else else");
        this.insertReport(reportForm, this.sqlparms,this.sqllabels);
      }
    }
  }

  public runSQlQuery(sqlquery: string, parms: string) {
    console.log("runSQlQuery() called");
    //console.log("sqlquery = "+sqlquery);
    //console.log("parms = "+parms);

    this.reportModelQuery.reportSql = sqlquery;
    this.reportModelQuery.sqlParams = parms;
    console.log(this.reportModelQuery);

    this.excelResponse = [];
    this.subscriptions.push(
      this.reportService.runReport(this.reportModelQuery).subscribe(
        (response: any) => {
          console.log("Response = " + JSON.stringify(response));
          this.dataSource = response;
          this.excelResponse = JSON.parse(JSON.stringify(response));
          this.displayedColumns = Object.keys(this.dataSource[0]).map(k => k);
          //console.log("this.displayedColumns === " + this.displayedColumns);
          this.sqlparms == "";
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }

  public insertReport(reportForm: NgForm, parms: string, sqllables: string) {
    console.log("insertReport");
    this.showLoading = true;
    const formData = this.reportService.createFormSave(reportForm.value, this.cat, this.distid, parms,sqllables);
    this.subscriptions.push(
      this.reportService.saveReport(formData).subscribe(
        (response: ReportModel) => {
          console.log("saveReport response=" + response);
          //this.clickButton('closeAddKPIButton');
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Report added successfully`);
          reportForm.reset();
          this.sqlparms = "";
          this.showLoading = false;
        },
        (errorResponse: HttpErrorResponse) => {
          console.log("saveReport errorResponse=" + errorResponse);
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          this.showLoading = false;
        }
      )
    );
  }



  exportExcel() {
    this.dataForExcel = [];
    let reportData = null;
    this.excelResponse.forEach((row: any) => {
      console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'Report',
      data: this.dataForExcel,
      headers: this.displayedColumns
    }
    this.ete.exportExcel(reportData);
    this.excelResponse = [];
  }

  public getDistributionData() {
    this.filteredDistOptions = this.myControlDist.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val1 => {
        return this.getDistList(val1 || '')
      })
    )
  }

  public getDistList(val1: string): Observable<any[]> {
    return this.reportService.getDistList()
      .pipe(
        map(response => response.filter(option => {
          this.resDist = response;
          return option.distName.toLowerCase().indexOf(val1.toLowerCase()) === 0
        }))
      )
  }
  public getSelectedDist(distri: number) {
    var cpdata = "";
    this.getDistributionData();
    //console.log("getSelectedDist === "+this.resDist);
    if(distri){
      cpdata = this.resDist.find(distribute => distribute.distId === distri).distName;
    }
    return cpdata;
  }

  public getCategoryData() {
    console.log("getCategoryData()");
    this.filteredCategoryOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(val2 => {
        return this.getCategoryList(val2 || '')
      })
    )
  }
  public getCategoryList(val2: string): Observable<any[]> {
    //console.log("getCategoryList()==" + val2);
    return this.reportService.getCatList()
      .pipe(
        map(res => res.filter(opt => {
          this.resCat = res;
          // console.log("this.resCat="+JSON.stringify(this.resCat));
          return opt.category.toLowerCase().indexOf(val2.toLowerCase()) === 0
        }))
      )
  }
  public getSelectedCat(desc: string) {
    //console.log("getSelectedCat()");
    var cpdata = "";
    this.getCategoryData();
    if(desc){
      cpdata = this.resCat.find(cat => cat.category === desc).category;
    }
    return cpdata;
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }



  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
